<template>
  <v-stepper v-model="step" elevation="0">    
    <v-stepper-header elevation="0" style="box-shadow: none;">
      <v-stepper-step :complete="step > 1" step="1" color="success">
        Veículos        
        <small>Placas dos veículos 
          <br> 
          <span v-if="vehiclesSetence">{{ vehiclesSetence }}</span>
          <span v-else>Nenhum veículo selecionado</span>
        </small>
      </v-stepper-step>

      <v-stepper-step :complete="step > 2" step="2" color="success">
        Pagamento <span v-if="group">R$ {{ group.total_amount}}</span>
        <small>Forma de pagamento</small>
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-form ref="newOrderForm" lazy-validation @submit.prevent="onSubmit">
          <v-row class="mb-2">
            <v-col :lg="6" :md="6" :sm="6" :xs="12">
              <v-card
                outlined
                class="pa-4 d-flex flex-column align-center justify-center"
                style="cursor: pointer; min-height: 100px;"
                :color="vehicleMode === 'existing' ? 'success' : ''"
                :dark="vehicleMode === 'existing'"
                @click="vehicleMode = 'existing'"
              >
                <v-icon large :color="vehicleMode === 'existing' ? 'white' : 'success'">directions_bus</v-icon>
                <span class="mt-2 font-weight-medium">Para veículo existente</span>
              </v-card>
            </v-col>
            <v-col :lg="6" :md="6" :sm="6" :xs="12">
              <v-card
                outlined
                class="pa-4 d-flex flex-column align-center justify-center"
                style="cursor: pointer; min-height: 100px;"
                :color="vehicleMode === 'new' ? 'success' : ''"
                :dark="vehicleMode === 'new'"
                @click="vehicleMode = 'new'"
              >
                <v-icon large :color="vehicleMode === 'new' ? 'white' : 'success'">bus_alert</v-icon>
                <span class="mt-2 font-weight-medium">Para novo veículo</span>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="vehicleMode === 'existing'">
            <v-col :lg="12" :md="12" :sm="12" :xs="12">
              <OrderVehicleAutoComplete v-model="vehicles" />
            </v-col>
          </v-row>
          <v-row v-else-if="vehicleMode === 'new'">
            <v-col :lg="12" :md="12" :sm="12" :xs="12">
              <OrderVehicleAdd v-model="vehicles" />
            </v-col>
          </v-row>
          <v-btn depressed color="success" type="submit" :disabled="!vehicles.length">
            Continuar
          </v-btn>    
        </v-form>        
      </v-stepper-content>

      <v-stepper-content step="2">        
        <GroupPaymentForm v-if="group" :group="group" />        
      </v-stepper-content>
    </v-stepper-items>   
  </v-stepper>
</template>

<script>
import GroupPaymentForm from './GroupPaymentForm.vue';
import OrderService from '@/services/order.service';
import OrderVehicleAutoComplete from './OrderVehicleAutoComplete.vue';
import OrderVehicleAdd from './OrderVehicleAdd.vue';

export default {
  name: "OrderCheckoutInspection",
  
  components: {
    OrderVehicleAutoComplete,
    OrderVehicleAdd,
    GroupPaymentForm
  },

  data: () => ({
    vehicles: [],
    vehiclesSetence: null,

    vehicleMode: 'existing',

    step: 1,

    group: null, 
    
    orders: [],

    orderKind: null,
  }),

  watch: {
    vehicles() {
      this.setVehiclesSetence();
    },

    vehicleMode() {
      this.vehicles = [];
    }
  },

  methods: {
    onSubmit() {
      if (!this.$refs.newOrderForm.validate()) return;      

      OrderService
        .bulkCreate(this.bulkCreatePayload())
        .subscribe(({data}) => {
          this.group = data.group;
          this.onEventOrderCreated();
      });
    },

    bulkCreatePayload() {      
      return {
        kind: 'AUTOVISTORIA_LAUDO_ENGENHEIRO_MECANICO',
        data: {
          vehicles: this.vehicles.map(vehicle => ({
            plate: vehicle.plate,
            transport_id: vehicle.transportId
          }))
        }
      }
    },

    setVehiclesSetence() {      
      this.vehiclesSetence = this.vehicles.map(vehicle => vehicle.plate).join(', ');
    },

    onEventOrderCreated() {
      this.step = 2;
    },

    fetchOrders() {
      const params = {
        input: {
          group: this.group.id
        }        
      }
      
      OrderService
        .list(params)
        .subscribe({
          next: ({items}) => {            
            this.orders = items;
          }
      });
    }
  },
};
</script>